import React, { useEffect, useState } from "react";

import {
  getLocationFormLastStep,
  getNextLocationStep,
  getPrevLocationStep,
} from "~/shared/utils/locationLogic";
import { SignUpFormProps } from "~/shared/utils/types";
import { useSignUpStore } from "~/stores";
import { LOCATION_FORM_STEPS } from "~/utils";
import {
  OfficePreferenceForm,
  StateForm,
  VisitTypePreferenceForm,
} from "./Location";

const formSteps: Record<LOCATION_FORM_STEPS, React.ComponentType<any>> = {
  [LOCATION_FORM_STEPS.STATE]: StateForm,
  [LOCATION_FORM_STEPS.VISIT_TYPE_PREFERENCE]: VisitTypePreferenceForm,
  [LOCATION_FORM_STEPS.OFFICE_PREFERENCE]: OfficePreferenceForm,
};

export const LocationForm = ({ onPrev, onNext }: SignUpFormProps) => {
  const [currentForm, setCurrentForm] = useState<keyof typeof formSteps>(
    LOCATION_FORM_STEPS.STATE,
  );
  const {
    patient,
    showLocationFinalStep,
    setShowLocationFinalStep,
    setShowInsuranceFinalStep,
  } = useSignUpStore();
  const { state, visitType } = patient;

  useEffect(() => {
    if (showLocationFinalStep) {
      setCurrentForm(getLocationFormLastStep(state, visitType));
      setShowLocationFinalStep(false);
    }
  }, []);

  const onNextLocationStep = (response?: string) => {
    const nextStep = getNextLocationStep(currentForm, response);
    if (nextStep) {
      setCurrentForm(nextStep);
    } else {
      onNext();
    }
  };
  const onPrevLocationStep = () => {
    if (currentForm === LOCATION_FORM_STEPS.STATE) {
      if (patient.secondaryInsurance?.providerName) {
        setShowInsuranceFinalStep(true);
      }
      onPrev();
    } else {
      const prevStep = getPrevLocationStep(currentForm);
      if (prevStep) setCurrentForm(prevStep);
    }
  };
  const CurrentComponent = formSteps[currentForm];
  return (
    <CurrentComponent onPrev={onPrevLocationStep} onNext={onNextLocationStep} />
  );
};
